<template>
  <div class="detail-comp">
    <div class="top">
      <a-space size="large">
        <span class="tool-title">{{ toolObj.toolName || "" }}</span>
        <a-button type="primary" icon="download" class="download-btn"
        @click="$emit('vertify', toolObj.downloadUri)"
        >下载</a-button>
      </a-space>
      <a-space class="info-item">
            <a-button type="link" icon="copy" class="label" @click="copyLink"
              >复制链接</a-button
            >
      </a-space>
      <p class="info-row">
        <a-space class="info-item">
          <a-icon type="folder" />
          <span class="label">{{ toolObj.toolsType || "" }}</span>
        </a-space>
        <a-space class="info-item">
          <a-icon type="clock-circle" />
          <span class="label">{{ toolObj.createData ? new Date(toolObj.createData).format("yyyy-MM-dd hh:mm") : "" }}</span>
        </a-space>
      </p>
    </div>
    <mavon-editor
      class="content"
      :toolbarsFlag="false"
      defaultOpen="preview"
      :value="toolObj.description"
      :subfield="false"
      :boxShadow="false"
      previewBackground="none"
    />
  </div>
</template>
<script>
import { mavonEditor } from "mavon-editor";
import "mavon-editor/dist/css/index.css";
export default {
  name: "detail-comp",
  props: {
    toolObj: {
      type: Object
    }
  },
  components: {
    mavonEditor,
  },
  data() {
    return {
      testUri: "https://seeyon-public.obs.cn-north-4.myhuaweicloud.com/v8.0-v8.0sp2%E7%99%BB%E5%BD%95%E5%89%8D%E6%8E%A5%E5%8F%A3%E8%B6%8A%E6%9D%83%E8%AE%BF%E9%97%AE%E5%8A%A0%E5%9B%BA%E8%A1%A5%E4%B8%81%28autoinstall%29.zip"
    };
  },
  created() {
    
  },
  methods: {
      copyLink() {
        if (this.toolObj && this.toolObj.shareUrl) {
            var originUrl = window.location.href ? window.location.href : "";
            const copyUrl = originUrl + "?shareUrl=" + this.toolObj.shareUrl
            this.$copyText(decodeURIComponent(copyUrl)).then(() => {
                this.$success({ title: "已成功复制到剪切板" });
            }).catch(() => {
                this.$error({ title: "复制失败" });
            });
        } else {
            this.$warning({ title: "链接不存在！" });
        }
      }
  },
  watch: {
    "toolObj.id"(value) {
      console.log(value);
      this.$emit("toDetail", value);
    },
  },
};
</script>
<style scoped>
.detail-comp {
  padding: 20px;
}
.top .tool-title {
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 24px;
  color: #111111;
  letter-spacing: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.download-btn {
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.45px;
  text-align: center;
}
.info-row {
  height: 22px;
  margin-top: 10px;
  margin-bottom: 30px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #8c8c8c;
  letter-spacing: 0;
}
.info-item {
  margin-right: 30px;
}
.content {
  height: calc(100% - 176px);
  overflow: auto;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  line-height: 30px;
}
::v-deep .v-note-wrapper {
  border: none;
}
::v-deep .v-note-wrapper .v-note-panel .v-note-show .v-show-content {
  padding-left: 0;
  padding-right: 0;
}
</style>